import type { MailboxInfo } from 'owa-client-types';
import getGlobalSettingsAccountMailboxInfo from '../selectors/getGlobalSettingsAccountMailboxInfo';
import isSameMailboxInfo from './isSameMailboxInfo';

export default function isGlobalSettingsMailbox(mailboxInfo: MailboxInfo): boolean {
    return isSameMailboxInfo(mailboxInfo, getGlobalSettingsAccountMailboxInfo());
}
